import { FC, useEffect, useState } from "react";
import { Box, Grid, TableCell, TableRow, Typography } from "@mui/material";
import CustomTable from "../../components/common/CustomTable/CustomTable";
import { useNavigate, useParams } from "react-router-dom";
import { moneyCL, moneyFormat } from "../../toolbox/helpers/money-helpers";
import { useRenditionBuildingStore } from "../../hooks/useRenditionBuildingStore";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import { CustomBackdrop } from "../../components/common/CustomBackdrop/CustomBackdrop";
import { UploadTranfersBuildingModal } from "../RenditionBuilding/components/UploadTransferBuildingModal";
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import { Card } from '@mui/material'
import {
    MonetizationOn,
    Percent,
    AccountBalanceWallet,
    WarningAmber,
    History,
    Paid,
    Calculate
} from '@mui/icons-material'

const columns = [
    { type: "text", field: "description", label: "DESCRIPCIÓN", align: "center" },
    { type: "text", field: "building", label: "EDIFICIO", align: "center" },
    { type: "text", field: "alicuota", label: "ALICUOTA", align: "center", format: (row) => `${row.alicuota} %` },
    {
        type: "text", field: "alicuota_amount", label: "MONTO ALICUOTA", align: "center",
        format: (row) => moneyCL(row.alicuota_amount)
    },
    {
        type: "text",
        field: "amount_individual",
        label: "TOTAL INDIVIDUAL",
        align: "center",
        format: (row) => moneyCL(row.amount_individual),
    },
    {
        type: "text",
        field: "amount_mes",
        label: "DEUDA DEL MES",
        align: "center",
        format: (row) => moneyCL(row.amount_mes),
    },
    {
        type: "text",
        field: "previous_month_balance",
        label: "DEUDA DEL MES ANTERIOR",
        align: "center",
        format: (row) => moneyCL(row.previous_month_balance),
    },
    {
        type: "text",
        field: "favor_month_balance",
        label: "SALDO A FAVOR",
        align: "center",
        format: (row) => moneyCL(row.favor_month_balance),
    },
    {
        type: "text",
        field: "total_pay",
        label: "TOTAL A PAGAR",
        align: "center",
        format: (row) => moneyCL(row.total_pay),
    },
    {
        type: "text",
        field: "total_paid",
        label: "TOTAL PAGADO",
        align: "center",
        format: (row) => moneyCL(row.total_paid),
    },
    {
        type: "text",
        field: "amount_balance",
        label: "BALANCE MES",
        align: "center",
        format: (row) => moneyCL(row.amount_balance),
    },
    { type: "detail", field: "detail", label: "", align: "center" },
];

export const RenditionBuildingDepartmentList: FC = () => {
    const { id } = useParams<{ id: string }>();
    const navigate = useNavigate();
    const {
        sendMailPDF,
        getDetailRendicionAll,
        getRenditionDetailPDF,
        selectedRenditionBuilding
    } = useRenditionBuildingStore();
    const [loading, setLoading] = useState(false);
    const [downloading, setDownloading] = useState(false);
    const [mailLoading, setMailLoading] = useState(false);
    const [mailsLoading, setMailsLoading] = useState(false);

    const [formattedData, setFormattedData] = useState<any[]>([]);
    const [showModalTransfer, setShowModalTransfer] = useState<boolean>(false)

    const [selectedRows, setSelectedRows] = useState<any[]>([]);
    const [allSelected, setAllSelected] = useState<boolean>(false);

    const totals = (() => {
        const result = formattedData.reduce((acc, item) => {
            acc.previous_month_balance += item.previous_month_balance
            acc.alicuota += item.alicuota
            acc.alicuota_amount += item.alicuota_amount
            acc.favor_month_balance += item.favor_month_balance
            acc.amount_individual += item.amount_individual
            acc.amount_mes += item.amount_mes
            acc.total_pay += item.total_pay
            acc.total_paid += item.total_paid
            acc.amount_balance += item.amount_balance
            return acc
        }, {
            previous_month_balance: 0,
            alicuota: 0,
            alicuota_amount: 0,
            favor_month_balance: 0,
            amount_individual: 0,
            amount_mes: 0,
            total_pay: 0,
            total_paid: 0,
            amount_balance: 0
        })

        return {
            ...result
        }
    })()

    useEffect(() => {
        if (id) {
            getDataDepartments();
        }
    }, [id]);

    const formatRenditionData = (dataArray) => {
        if (!Array.isArray(dataArray)) return [];

        return dataArray.map((data) => ({
            description: `Rendición de ${data.department.department_name} - ${data.department.title}`,
            building: data.department.building,
            subtotal: data.data.general.total,
            amount_individual: parseInt(data.data.individual.total),
            amount_mes: parseInt(data.data.subtotal),
            previous_month_balance: parseFloat(data.data.saldoMesAnterior),
            favor_month_balance: parseInt(data.data.saldoFavorMesAnterior),
            total_pay: parseFloat(data.data.total_pagar),
            total_paid: parseInt(data.data.total_pagado),
            iddepartment: data.department.iddepartment,
            amount_balance: parseInt(data.data.balanceMes),
            alicuota: parseFloat(data.data.alicuota),
            alicuota_amount: parseInt(data.data.general.total),
            total_building: parseInt(data.data.edificio.total),
            total_general_spents: data.data.total_general_spents,
            background: data.data.background,
            message_warning: data.data.message_warning,
        }));
    };

    const getDataDepartments = async () => {
        try {
            setLoading(true)
            const response = await getDetailRendicionAll({ idreport_building: id });

            if (response && Array.isArray(response)) {
                const formatted = formatRenditionData(response);
                setFormattedData(formatted);
            }
            setLoading(false)
        } catch (error) {
            console.error("Error al obtener la rendición:", error);
        }
    };

    const onHelper = async (rowSelected) => {
        setDownloading(true);
        try {
            const parsedId = id ? parseInt(id, 10) : 0
            const response = await getRenditionDetailPDF(parsedId, rowSelected.iddepartment);
            if (response !== false) {
                const blob = new Blob([response], { type: "application/pdf" });
                const bloblURL = URL.createObjectURL(blob);
                window.open(bloblURL, "_blank");
            }
        } finally {
            setDownloading(false);
        }
    };

    const onAdd = async () => {
        setShowModalTransfer(true)
    }

    const closeModalTransfer = async () => {
        setShowModalTransfer(false);
        await getDataDepartments();
    }

    const onMailing = async (rowSelected) => {
        setMailLoading(true)
        const payload = {
            iddepartments: [rowSelected.iddepartment],
            idreport_building: id
        }
        await sendMailPDF(payload)
        setMailLoading(false)
        setSelectedRows([]);
        setAllSelected(false);
    }

    const onMailingMasive = async () => {
        setMailsLoading(true)
        const iddepartments = selectedRows.map((item) => item.iddepartment);
        const payload = {
            iddepartments: iddepartments,
            idreport_building: id
        }
        await sendMailPDF(payload)
        setMailsLoading(false)
        setSelectedRows([]);
        setAllSelected(false);
    }

    const onCheckbox = (row: any) => {
        const selectedIndex = selectedRows.findIndex(selectedRow => selectedRow.iddepartment === row.iddepartment);
        let newSelected: any = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selectedRows, row);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selectedRows.slice(1));
        } else if (selectedIndex === selectedRows.length - 1) {
            newSelected = newSelected.concat(selectedRows.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selectedRows.slice(0, selectedIndex),
                selectedRows.slice(selectedIndex + 1)
            );
        }
        setSelectedRows(newSelected);
        setAllSelected(newSelected.length === formattedData.length);

    };

    const selectAllRows = () => {
        if (allSelected) {
            setSelectedRows([]);
            setAllSelected(false);
        } else {
            setSelectedRows(formattedData);
            setAllSelected(true);
        }
    };

    const isSelected = (row: any) => selectedRows.some(selectedRow => selectedRow.iddepartment === row.iddepartment);

    const finalRow = (
        <TableRow>
            <TableCell colSpan={2} align="center" style={{ background: "#89B2DF", color: "#fff" }}>
                <strong>TOTAL</strong>
            </TableCell>
            <TableCell align="right" style={{ background: "#D8E8F7" }}>
                <strong>{parseFloat(totals.alicuota.toFixed(4))}%</strong>
            </TableCell>
            <TableCell align="right" style={{ background: "#D8E8F7" }}>
                <strong>{moneyCL(totals.alicuota_amount)}</strong>
            </TableCell>
            <TableCell align="right" style={{ background: "#D8E8F7" }}>
                <strong>{moneyCL(totals.amount_individual)}</strong>
            </TableCell>
            <TableCell align="right" style={{ background: "#D8E8F7" }}>
                <strong>{moneyCL(totals.amount_mes)}</strong>
            </TableCell>
            <TableCell align="right" style={{ background: "#D8E8F7" }}>
                <strong>{moneyCL(totals.previous_month_balance)}</strong>
            </TableCell>
            <TableCell align="right" style={{ background: "#D8E8F7" }}>
                <strong>{moneyCL(totals.favor_month_balance)}</strong>
            </TableCell>
            <TableCell align="right" style={{ background: "#D8E8F7" }}>
                <strong>{moneyCL(totals.total_pay)}</strong>
            </TableCell>
            <TableCell align="right" style={{ background: "#D8E8F7" }}>
                <strong>{moneyCL(totals.total_paid)}</strong>
            </TableCell>
            <TableCell align="right" style={{ background: "#D8E8F7" }}>
                <strong>{moneyCL(totals.amount_balance)}</strong>
            </TableCell>
            <TableCell style={{ background: "#D8E8F7" }}></TableCell>
        </TableRow>
    )

    const indicators = [
        {
            label: 'Gastos comunes registrados',
            value: moneyCL(selectedRenditionBuilding?.amount_general || 0),
            bg: '#E3F2FD',
        },
        {
            label: 'Alicuota asignada',
            value: `${parseFloat(selectedRenditionBuilding?.total_alicuota).toFixed(4)}%`,
            bg: '#FFF3E0',
        },
        {
            label: 'Alicuota ejecutada',
            value: moneyCL(totals.alicuota_amount),
            bg: '#E8F5E9',
        },
        {
            label: 'Gastos individuales registrados',
            value: moneyCL(selectedRenditionBuilding?.amount_individual || 0),
            bg: '#F3E5F5',
        },
        {
            label: 'Deuda del mes',
            value: moneyCL(
                (totals.alicuota_amount || 0) +
                (selectedRenditionBuilding?.amount_individual || 0)
            ),
            bg: '#FFEBEE',
        },
        {
            label: 'Deuda del mes anterior',
            value: moneyCL(
                (totals.previous_month_balance || 0)
            ),
            bg: '#FFEBEE',
        },
        {
            label: 'Total de la rendición',
            value: moneyCL(
                (totals.total_pay || 0)
            ),
            bg: '#FFEBEE',
        },
        {
            label: 'Total pagado',
            value: moneyCL(selectedRenditionBuilding?.total_paid || 0),
            bg: '#E3F2FD',
        },
        {
            label: 'Balance final',
            value: moneyCL(selectedRenditionBuilding?.total_balance || 0),
            bg: '#FFFDE7',
        }

    ]

    const indicatorCards = [
        {
            icon: <MonetizationOn sx={{ fontSize: 32, color: '#4caf50' }} />,
            label: 'Gastos comunes registrados',
            value: indicators[0]?.value || '0',
            bg: '#E8F5E9'
        },
        {
            icon: <Percent sx={{ fontSize: 32, color: '#1976d2' }} />,
            label: 'Alicuota asignada',
            value: indicators[1]?.value || '0',
            bg: '#E3F2FD'
        },
        {
            icon: <AccountBalanceWallet sx={{ fontSize: 32, color: '#ff9800' }} />,
            label: 'Alicuota ejecutada',
            value: indicators[2]?.value || '0',
            bg: '#FFF3E0'
        },
        {
            icon: <MonetizationOn sx={{ fontSize: 32, color: '#9c27b0' }} />,
            label: 'Gastos individuales registrados',
            value: indicators[3]?.value || '0',
            bg: '#F3E5F5'
        },
        {
            icon: <WarningAmber sx={{ fontSize: 32, color: '#d32f2f' }} />,
            label: 'Deuda del mes',
            value: indicators[4]?.value || '0',
            bg: '#FFEBEE'
        },
        {
            icon: <History sx={{ fontSize: 32, color: '#6d4c41' }} />,
            label: 'Deuda del mes anterior',
            value: indicators[5]?.value || '0',
            bg: '#EFEBE9'
        },
        {
            icon: <Paid sx={{ fontSize: 32, color: '#2e7d32' }} />,
            label: 'Total de la rendición',
            value: indicators[6]?.value || '0',
            bg: '#E8F5E9'
        },
        {
            icon: <Paid sx={{ fontSize: 32, color: '#0288d1' }} />,
            label: 'Total pagado',
            value: indicators[7]?.value || '0',
            bg: '#E1F5FE'
        },
        {
            icon: <Calculate sx={{ fontSize: 32, color: '#6a1b9a' }} />,
            label: 'Balance final',
            value: indicators[8]?.value || '0',
            bg: '#F3E5F5'
        }
    ]

    return (
        <>
            {downloading && <CustomBackdrop open={true} />}
            {mailLoading && <CustomBackdrop open={true} />}
            {mailsLoading && <CustomBackdrop open={true} />}
            <Grid item container sx={{ alignItems: 'center', display: 'flex', justifyContent: 'center', flexWrap: 'wrap', marginBottom: '10px' }}>
                <Typography variant='h6' component='h1' gutterBottom sx={{ mt: 1, ml: 1 }} className='title-main'>
                    {`RENDICIONES DE DEPARTAMENTOS: ${selectedRenditionBuilding?.building || ''} - ${selectedRenditionBuilding?.month || ''}/${selectedRenditionBuilding?.year || ''}`}
                </Typography>
            </Grid>

            <Grid container spacing={2} sx={{ mb: 3 }} style={{ display: "flex", justifyContent: "center" }}>
                {indicatorCards.map((card, idx) => (
                    <Grid item xs={12} sm={6} md={4} lg={3} key={idx}>
                        <Card sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            p: 2,
                            bgcolor: card.bg,
                            borderRadius: 2,
                            height: '100%',
                            boxShadow: 1,
                        }}>
                            <Box>{card.icon}</Box>
                            <Box textAlign="right">
                                <Typography variant="body2" color="text.secondary">
                                    {card.label}
                                </Typography>
                                <Typography variant="h6" fontWeight="bold">
                                    {card.value}
                                </Typography>
                            </Box>
                        </Card>
                    </Grid>
                ))}
            </Grid>

            <Grid item xs={12}>
                <CustomTable
                    columns={columns}
                    rows={formattedData}
                    onRowClick={() => { }}
                    loading={loading}
                    hasOptions
                    isSelected={isSelected}
                    onCheckbox={onCheckbox}
                    selectAll={selectAllRows}
                    allSelected={allSelected}
                    onAddFn={onAdd}
                    onAddFnName={'REGISTRAR ABONO'}
                    onAddFn2={onMailingMasive}
                    onAddFnName2={'ENVIAR CORREOS'}
                    disabledAdd2={selectedRows.length == 0}
                    onHelper={onHelper}
                    icon_helper={<PictureAsPdfIcon fontSize="small" />}
                    tooltip_helper={"Ver PDF"}
                    onHelper2={onMailing}
                    icon_helper2={<MailOutlineIcon fontSize="small" />}
                    tooltip_helper2={"Enviar mail"}
                    finalRow={finalRow}
                />
            </Grid>
            {
                showModalTransfer && (
                    <UploadTranfersBuildingModal
                        open={showModalTransfer}
                        closeModal={closeModalTransfer}
                        isAdmin={true}
                        isPayment={true}
                    />
                )
            }
        </>
    );
};
